import { render, staticRenderFns } from "./LocalchainView.vue?vue&type=template&id=1969e2b2&scoped=true"
import script from "./LocalchainView.vue?vue&type=script&lang=js"
export * from "./LocalchainView.vue?vue&type=script&lang=js"
import style0 from "./LocalchainView.vue?vue&type=style&index=0&id=1969e2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1969e2b2",
  null
  
)

export default component.exports